export default __webpack_public_path__ + "static/media/crow@2x.f7a7ffa8.png";